module.exports = __webpack_public_path__ + "img/ico_talk_user_2.f5cd6d77.png";